(function () {
    'use strict';

    var module = angular
         .module("app");


    module.factory("bus",
    [
        '$rootScope',
        function bus($rootScope) {

            function publish(topic) {
                if (!topic)
                    throw "You must publish a topic";
                $rootScope.$broadcast(topic);
            }

            function subscribe(topic, callback, scope) {
                // If you directly bind to $rootScope.$on() from within a controller, you have to 
                // clean up the binding yourself when your local $scope gets destroyed. 
                // This is because controllers an get instantiated multiple times over the lifetime 
                // of an application which would result into bindings creating memory leaks.
                // In summary, if subscribing in a controller, pass in scope

                var unbind = $rootScope.$on(topic, callback);
                if (scope) {
                    scope.$on('$destroy', unbind);
                }
            }

            var service = {
                publish: publish,
                subscribe: subscribe
            };
            return service;
        }
    ]);
}());